import IconAdHocInvoice from "assets/img/icon-adhoc-invoice.svg?react"

import { useTranslation } from "react-i18next"

import Tooltip from "components/Tooltip/Tooltip"

const AdHocInvoiceIcon = () => {
    const { t } = useTranslation()

    return (
        <Tooltip
            content={t('adHocInvoice.adHocInvoice')}
            trigger="hover">
            <IconAdHocInvoice
                width={17}
                height={17}
                className="d-block"
                data-testid="adhoc-invoice-icon"
            />
        </Tooltip>
    )
}

export default AdHocInvoiceIcon
